<section class="mb-col-12">
  @if (name) {
    <h6
      class="title"
      i18n="@@related_las_personas_que_vieron_el_x_tambien_consultaron_estos_alojamientos"
    >
      Las personas que vieron el {{ name }} también consultaron estos alojamientos
    </h6>
  }

  @if (related?.length > 0) {
    <div class="hotel-container">
      @for (
        related of related | slice: 0 : (section === 'Detail' ? 3 : 2);
        track trackByItems($index, related)
      ) {
        <div class="hotel-container__item" (click)="openRelated(related)">
          <mb-recommended-card
            [rating]="related.rating"
            [name]="related.name"
            [stars]="related.stars"
            [pricePerNigth]="priceByValue === 'NIGHT'"
            [image]="addImageHotel(related?.images)"
            [includedTaxes]="showAmountTotal"
          >
            @if (!isAlliance) {
              <p class="price price--lg">
                <span class="price__currency"
                  >{{ related.rate.price.currency.code }}&nbsp;</span
                >
                <span class="price__amount">{{ related.priceTotalToShow | Currency }}</span>
              </p>
            }
            @if (isAlliance) {
              <am-rewards-pricing [price]="related.superclubPrice"></am-rewards-pricing>
            }
          </mb-recommended-card>
        </div>
      }
    </div>
  }

  <div class="hotel-container--mobile">
    @for (
      related of related | slice: 0 : (section === 'Detail' ? 3 : 2);
      track trackByItems($index, related)
    ) {
      <div class="mb-col-11 hotel-container--mobile__card-wrapper">
        <mb-recommended-card
          [rating]="related.rating"
          [name]="related.name"
          [stars]="related.stars"
          [pricePerNigth]="priceByValue === 'NIGHT'"
          [image]="addImageHotel(related?.images)"
          [includedTaxes]="showAmountTotal"
          (click)="openRelated(related)"
        >
          @if (!isAlliance) {
            <p class="price price--lg">
              <span class="price__currency"
                >{{ related.rate.price.currency.code }}&nbsp;</span
              >
              <span class="price__amount">{{ related.priceTotalToShow | Currency }}</span>
            </p>
          }
          @if (isAlliance) {
            <am-rewards-pricing [price]="related.superclubPrice"></am-rewards-pricing>
          }
        </mb-recommended-card>
      </div>
    }
  </div>
</section>
